/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPaginationResponseAllOfDataInner
 */
export interface OrderPaginationResponseAllOfDataInner {
    /**
     * 注文日時
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    orderDate?: string;
    /**
     * 注文種別（01:即時, 02:日時指定）
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    orderType?: string;
    /**
     * 実行状況 (1:未完了, 2:完了, 3:キャンセル, 4:予約(将来対応), 5:探車失敗)
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    orderStatus?: string;
    /**
     * 配車状態（1:配車中（未応答）, 2:探車失敗, 3:迎車中（現着前）, 4:迎車中（現着済）, 5:実車中, 6:代車要請中, 7:支払完了, 8:支払中（決済失敗）, 9:実車中, 11:利用者キャンセル, 12:事業者キャンセル, 13:QR連携キャンセル）
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    carDispatchStatus?: string;
    /**
     * 無線番号
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    radioNo?: string;
    /**
     * お客様名
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    passengerName?: string;
    /**
     * 電話番号
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    passengerTel?: string;
    /**
     * 注文時の迎車地
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    departureAddress?: string;
    /**
     * 注文番号
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    orderNo?: string;
    /**
     * ドライバー名
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    driverName?: string;
    /**
     * 収受総額
     * @type {number}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    actualFare?: number;
    /**
     * 実績支払い方法 (0:車内支払, 1:アプリ支払（クレカ）, 3:アプリ支払（Apple Pay）, 4:RingoPass支払, 5:後席決済（汎用QR）, 6:アプリ支払（CABカード）, 7:アプリ支払（S.RIDE Biz）, 10:アプリ支払（PayPay）, 11:アプリ支払（auPay）, 12:アプリ支払（d払い）, 13:アプリ支払（R Pay））
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    paymentMethod?: string;
    /**
     * グループ名
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    companyName?: string;
    /**
     * グループコード
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    companyCode?: string;
    /**
     * 会社名
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    subCompanyName?: string;
    /**
     * 会社コード
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    companyId?: string;
    /**
     * 営業所名
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    salesOfficeName?: string;
    /**
     * 営業所コード
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    salesOfficeId?: string;
    /**
     * 注文メモの有無
     * @type {boolean}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    hasOrderMemo?: boolean;
    /**
     * 決済種別 (-1:汎用QR, 0:WechatPay, 1:ALIPay, 2:AEONPay, 3:R Pay, 5:PayPay, 6:メルペイ, 7:d払い, 8:LINEPay, 9:auPay, 10:J-Coin Pay, 11:銀聯QR, 12:Alipay+)
     * @type {string}
     * @memberof OrderPaginationResponseAllOfDataInner
     */
    settlementType?: string;
}

/**
 * Check if a given object implements the OrderPaginationResponseAllOfDataInner interface.
 */
export function instanceOfOrderPaginationResponseAllOfDataInner(value: object): value is OrderPaginationResponseAllOfDataInner {
    return true;
}

export function OrderPaginationResponseAllOfDataInnerFromJSON(json: any): OrderPaginationResponseAllOfDataInner {
    return OrderPaginationResponseAllOfDataInnerFromJSONTyped(json, false);
}

export function OrderPaginationResponseAllOfDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPaginationResponseAllOfDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'orderDate': json['order_date'] == null ? undefined : json['order_date'],
        'orderType': json['order_type'] == null ? undefined : json['order_type'],
        'orderStatus': json['order_status'] == null ? undefined : json['order_status'],
        'carDispatchStatus': json['car_dispatch_status'] == null ? undefined : json['car_dispatch_status'],
        'radioNo': json['radio_no'] == null ? undefined : json['radio_no'],
        'passengerName': json['passenger_name'] == null ? undefined : json['passenger_name'],
        'passengerTel': json['passenger_tel'] == null ? undefined : json['passenger_tel'],
        'departureAddress': json['departure_address'] == null ? undefined : json['departure_address'],
        'orderNo': json['order_no'] == null ? undefined : json['order_no'],
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'actualFare': json['actual_fare'] == null ? undefined : json['actual_fare'],
        'paymentMethod': json['payment_method'] == null ? undefined : json['payment_method'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'companyCode': json['company_code'] == null ? undefined : json['company_code'],
        'subCompanyName': json['sub_company_name'] == null ? undefined : json['sub_company_name'],
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'salesOfficeName': json['sales_office_name'] == null ? undefined : json['sales_office_name'],
        'salesOfficeId': json['sales_office_id'] == null ? undefined : json['sales_office_id'],
        'hasOrderMemo': json['has_order_memo'] == null ? undefined : json['has_order_memo'],
        'settlementType': json['settlement_type'] == null ? undefined : json['settlement_type'],
    };
}

export function OrderPaginationResponseAllOfDataInnerToJSON(json: any): OrderPaginationResponseAllOfDataInner {
    return OrderPaginationResponseAllOfDataInnerToJSONTyped(json, false);
}

export function OrderPaginationResponseAllOfDataInnerToJSONTyped(value?: OrderPaginationResponseAllOfDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order_date': value['orderDate'],
        'order_type': value['orderType'],
        'order_status': value['orderStatus'],
        'car_dispatch_status': value['carDispatchStatus'],
        'radio_no': value['radioNo'],
        'passenger_name': value['passengerName'],
        'passenger_tel': value['passengerTel'],
        'departure_address': value['departureAddress'],
        'order_no': value['orderNo'],
        'driver_name': value['driverName'],
        'actual_fare': value['actualFare'],
        'payment_method': value['paymentMethod'],
        'company_name': value['companyName'],
        'company_code': value['companyCode'],
        'sub_company_name': value['subCompanyName'],
        'company_id': value['companyId'],
        'sales_office_name': value['salesOfficeName'],
        'sales_office_id': value['salesOfficeId'],
        'has_order_memo': value['hasOrderMemo'],
        'settlement_type': value['settlementType'],
    };
}

